"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Episode = void 0;
var program_1 = require("./program");
var helpers_1 = require("../../helpers/");
var Episode = (function (_super) {
    __extends(Episode, _super);
    function Episode(data) {
        var _a, _b;
        var _this = _super.call(this, data) || this;
        _this.title = helpers_1.generateSecondaryTitle(data === null || data === void 0 ? void 0 : data.seasonNumber, data === null || data === void 0 ? void 0 : data.tvSeasonEpisodeNumber);
        _this.secondaryTitle = ((_a = data.series) === null || _a === void 0 ? void 0 : _a.title) || (data === null || data === void 0 ? void 0 : data.title) || '';
        _this.slug = ((_b = data.series) === null || _b === void 0 ? void 0 : _b.slug) || '';
        if (data.series) {
            _this.kijkLink = "https://www.kijk.nl/programmas/" + data.series.slug + "/" + _this.guid;
        }
        return _this;
    }
    return Episode;
}(program_1.Program));
exports.Episode = Episode;
